(function ($) {
    let $fn = $("#layout_footer");

    if ($fn.length) {
        $fn.on("click","[data-scroll]",function () {
            $("#layout_main").anchor_anim(500);
        })
    }
})(jQuery);